<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5"> 
    <loading v-if="loadingState" />
    <div class="container whiteCont mt-5 mb-5">

			<div class="row justify-content-center verticalCentred">

				<div class="col-6 mt-5 pt-5">
					<h1 class="mb-5 center" v-model="result" type="text">{{result}}</h1>
					<div v-if="status" class="mt-5 center">
					<router-link class="btn btn-primary btn-lg" to="/login">Accedi</router-link>
				</div>

				</div>
			</div>

		</div>

	</div>
</template>


<script>
  import axios from 'axios'
  export default {
	name: 'confirm',
	components: {
		},
	data () {

      return {
        result: 'Verifica Token',
		status: false,
		loading: false
      }
    },
    methods: {
      confirm: function () {
        const token = this.$route.query.token
		if ( token ){
			this.loading = true
			axios({
				url: process.env.ROOT_API + 'fapi/confirmAccount',
				data: {
					token: token
				},
				method: 'POST',
				headers: {'Authorization': 'Bearer '+ process.env.AUTH_TOKEN, 'Content-type': 'application/json'} })
			.then(resp => {
				this.status = true
				this.loading = false
				this.result = 'Il tuo account è stato attivato.'

			})
			.catch(resp => {
				this.loading = false
				this.result = process.env.MSG_CONFIRM_TOKEN_NOT_FOUND

			})
		}else{
			this.result = process.env.MSG_CONFIRM_TOKEN_NOT_FOUND

		}
      }
    },
	beforeMount(){
		this.confirm()
	},

  }

</script>



// WEBPACK FOOTER //
// src/components/confirm/index.vue